<template>
  <v-container>
    <v-row>
      <v-col sm="3">
        <v-card>
          <v-card-title>Mitarbeiter</v-card-title>
          <v-card-text>
            <div v-if="Users.length >= 0">
              <div>Gesamt: {{ Users.length }}</div>
              <div>Aktiv: {{ activeUsers }}</div>
              <div>Inaktiv: {{ inactiveUsers }}</div>
              <div>Nicht aktiviert: {{ notActivatedUsers }}</div>
            </div>

            <h2 v-else>Keine Daten verfügbar</h2>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// @ is an alias to /src
export default {
  name: "DashboardAdmin",
  data: () => ({
    totalCustomers: 0,
    totalUsers: 0,
    userStats: null
  }),
  components: {},
  methods: {},
  computed: {
    Users() {
      return this.$store.getters["user/getUserList"];
    },
    User() {
      return this.$store.getters["user/getUser"];
    },
    activeUsers() {
      return this.Users.filter(
        el =>
          el.active === true && el.customerId === String(this.User.customerId)
      ).length;
    },
    inactiveUsers() {
      return this.Users.filter(
        el =>
          el.active !== true && el.customerId === String(this.User.customerId)
      ).length;
    },
    notActivatedUsers() {
      return this.Users.filter(
        el =>
          el.activation.activated !== true &&
          el.customerId === String(this.User.customerId)
      ).length;
    }
  },
  created() {
    //DataService.apiClient.get("/stats/customers")
    this.$store
      .dispatch("customer/fetchCustomerList")
      .then(result => {
        this.totalCustomers = result.data.data.length;
      })
      .catch(() => {
        this.totalCustomers = -1;
      });

    this.$store
      .dispatch("user/fetchUserList")
      .then(result => {
        this.totalUsers = result.data.data;
      })
      .catch(() => {
        this.totalUsers = -1;
      });

    /*DataService.apiClient
      .get("/stats/users")
      .then(result => {
        this.userStats = result.data.data.userStats;
      })
      .catch(() => {
        this.userStats = null;
      });*/
  }
};
</script>
<style scoped></style>
